import { render, staticRenderFns } from "./draftProductShopee.vue?vue&type=template&id=5e7094cb&scoped=true"
import script from "./draftProductShopee.vue?vue&type=script&lang=js"
export * from "./draftProductShopee.vue?vue&type=script&lang=js"
import style0 from "./draftProductShopee.vue?vue&type=style&index=0&id=5e7094cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7094cb",
  null
  
)

export default component.exports